import React, { useEffect, useState } from 'react'
import { Icon } from '@iconify/react'
import Layout from '../../../../brands/components/Layout'
import { useNavigate } from 'react-router-dom'
import { Dropdown } from 'react-bootstrap'
import { useAppDispatch } from '../../../../../redux/hook'
import {
    HIDE_LOADER,
    SHOW_LOADER,
} from '../../../../../redux/slices/LoaderSlice'
import { SHOW_NOTIFICATION } from '../../../../../redux/slices/showNotificationSlice'
import { getAssignedPrograms } from '../../api'
import { AssignProgram } from '../../type'
import { markAsCompleted } from '../../../viewresources/api/index'
import { formatDate } from '../../utils/index'
import './index.css'

const EmpResources: React.FC = () => {
    const navigate = useNavigate()
    const dispatch = useAppDispatch()
    const [currentPage, setCurrentPage] = useState<number>(1)
    const [totalCount, setTotalCount] = useState<number>(0)
    const totalPages = Math.ceil(totalCount / 7)
    const [programassignlist, setProgramAssignList] = useState<AssignProgram[]>(
        []
    )

    useEffect(() => {
        dispatch(SHOW_LOADER())
        const fetchData = async () => {
            try {
                // Call the asynchronous function and wait for its result
                const programData = await getAssignedPrograms({
                    currentPage: currentPage,
                    recordsPerPage: 5,
                })
                programData?.data?.data?.sort(
                    (a: { assignedOn: string }, b: { assignedOn: string }) =>
                        new Date(b.assignedOn).getTime() -
                        new Date(a.assignedOn).getTime()
                )
                setProgramAssignList(programData?.data?.data)
                setTotalCount(programData?.data?.totalCount)
                setCurrentPage(1)

                // Dispatch the action with the data if needed

                dispatch(HIDE_LOADER())
            } catch (err) {
                dispatch(HIDE_LOADER())
                // Handle any errors here
                console.error('Error fetching :', err, totalPages)
            }
        }

        // Call the function to fetch data
        fetchData()
    }, [currentPage])

    const handleMarkAsCompleted = async (id: string) => {
        dispatch(SHOW_LOADER())
        try {
            const response = await markAsCompleted(id)
            if (response.status === 200) {
                dispatch(
                    SHOW_NOTIFICATION({
                        message: response.data,
                        type: 'success',
                    })
                )
            }
        } catch (error) {
            console.error(error)
        } finally {
            dispatch(HIDE_LOADER())
        }
    }

    return (
        <div>
            <Layout custom={true}>
                <div className="col-12 grid-custom-table">
                    <div className="page-information mb-3">
                        <div className="d-flex justify-content-between">
                            <div>
                                <h4>Training Programs</h4>
                            </div>
                            <div></div>
                        </div>
                    </div>
                    <div className="custom-table resources">
                        <table>
                            <tr>
                                <th>Title</th>
                                <th></th>
                                <th>Actions</th>
                            </tr>

                            {programassignlist.map(
                                (program: AssignProgram, index: number) => {
                                    const formattedDate = formatDate(
                                        program.assignedOn
                                    )
                                    return (
                                        <tr key={`${program}-${index}`}>
                                            <td>
                                                <span
                                                    onClick={() => {
                                                        navigate(
                                                            `/teacher/resources-view/${program.trainingFolderId}?program=${program.folderName}`,
                                                            {
                                                                state: {
                                                                    trainingFolderId:
                                                                        program.trainingFolderId,
                                                                },
                                                            }
                                                        )
                                                    }}
                                                    className="resource-title"
                                                >
                                                    {' '}
                                                    {program.folderName}
                                                </span>
                                            </td>
                                            <td>Assigned on {formattedDate}</td>
                                            <td>
                                                <div className="dropdown-custom-link">
                                                    {' '}
                                                    <Dropdown>
                                                        <Dropdown.Toggle
                                                            variant="success"
                                                            id="dropdown-basic"
                                                        >
                                                            <Icon icon="mage:dots" />
                                                        </Dropdown.Toggle>

                                                        <Dropdown.Menu>
                                                            <Dropdown.Item
                                                                onClick={() => {
                                                                    navigate(
                                                                        `/teacher/resources-view/${program.trainingFolderId}?program=${program.folderName}`,
                                                                        {
                                                                            state: {
                                                                                trainingFolderId:
                                                                                    program.trainingFolderId,
                                                                            },
                                                                        }
                                                                    )
                                                                }}
                                                            >
                                                                View
                                                            </Dropdown.Item>
                                                            <Dropdown.Item
                                                                onClick={() =>
                                                                    handleMarkAsCompleted(
                                                                        program.trainingFolderId
                                                                    )
                                                                }
                                                            >
                                                                Mark as
                                                                completed
                                                            </Dropdown.Item>
                                                        </Dropdown.Menu>
                                                    </Dropdown>
                                                </div>
                                            </td>
                                        </tr>
                                    )
                                }
                            )}
                            {/* <tr>
                                <td>Health and Safety Training</td>
                                <td>Assigned on 05/23/2024</td>
                                <td>
                                    <div className="dropdown-custom-link">
                                        {' '}
                                        <Dropdown>
                                            <Dropdown.Toggle
                                                variant="success"
                                                id="dropdown-basic"
                                            >
                                                <Icon icon="mage:dots" />
                                            </Dropdown.Toggle>

                                            <Dropdown.Menu>
                                                <Dropdown.Item
                                                    onClick={() => {
                                                        navigate(
                                                            '/employee/resources-view'
                                                        )
                                                    }}
                                                >
                                                    View
                                                </Dropdown.Item>
                                                <Dropdown.Item>
                                                    Mark as completed
                                                </Dropdown.Item>
                                            </Dropdown.Menu>
                                        </Dropdown>
                                    </div>
                                </td>
                            </tr>

                            <tr>
                                <td>Anger Management Training</td>
                                <td>Assigned on 05/23/2024</td>
                                <td>
                                    <div className="dropdown-custom-link">
                                        {' '}
                                        <Dropdown>
                                            <Dropdown.Toggle
                                                variant="success"
                                                id="dropdown-basic"
                                            >
                                                <Icon icon="mage:dots" />
                                            </Dropdown.Toggle>

                                            <Dropdown.Menu>
                                                <Dropdown.Item
                                                    onClick={() => {
                                                        navigate(
                                                            '/employee/resources-view'
                                                        )
                                                    }}
                                                >
                                                    View
                                                </Dropdown.Item>
                                                <Dropdown.Item>
                                                    Mark as completed
                                                </Dropdown.Item>
                                            </Dropdown.Menu>
                                        </Dropdown>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>Anger Management Training</td>
                                <td>Assigned on 05/23/2024</td>
                                <td>
                                    <div className="dropdown-custom-link">
                                        {' '}
                                        <Dropdown>
                                            <Dropdown.Toggle
                                                variant="success"
                                                id="dropdown-basic"
                                            >
                                                <Icon icon="mage:dots" />
                                            </Dropdown.Toggle>

                                            <Dropdown.Menu>
                                                <Dropdown.Item
                                                    onClick={() => {
                                                        navigate(
                                                            '/employee/resources-view'
                                                        )
                                                    }}
                                                >
                                                    View
                                                </Dropdown.Item>
                                                <Dropdown.Item>
                                                    Mark as completed
                                                </Dropdown.Item>
                                            </Dropdown.Menu>
                                        </Dropdown>
                                    </div>
                                </td>
                            </tr> */}
                        </table>
                    </div>
                    <></>
                </div>
            </Layout>
        </div>
    )
}

export default EmpResources
